/* ==========================================================================
   Alivia — comportamiento propio de la tienda. Sin librerías externas.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll --------------------------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.al-reveal, .al-stagger');
    if (!elementos.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('al-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('al-visible');
          observador.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* --- Cifras que cuentan hacia arriba ---------------------------------- */
  function initContadores() {
    var cifras = document.querySelectorAll('[data-al-contador]');
    if (!cifras.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-al-contador'));
      if (isNaN(destino)) return;
      if (reduce) { el.textContent = String(destino); return; }

      var duracion = 1400;
      var inicio = null;

      function paso(ahora) {
        if (!inicio) inicio = ahora;
        var avance = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - avance, 3);
        var valor = destino * suave;
        el.textContent = destino % 1 === 0 ? String(Math.round(valor)) : valor.toFixed(1);
        if (avance < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(animar);
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          animar(entrada.target);
          observador.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.5 });

    cifras.forEach(function (el) { observador.observe(el); });
  }

  /* --- Galería de la página de producto --------------------------------- */
  function initGaleria() {
    var galeria = document.querySelector('[data-al-galeria]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-al-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-al-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var grande = mini.getAttribute('data-al-mini');
        if (!grande) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.setAttribute('src', grande);
          principal.style.opacity = '1';
        }, 140);
        minis.forEach(function (m) { m.classList.remove('al-activa'); });
        mini.classList.add('al-activa');
      });
    });
  }

  /* --- Selector de variantes de la página de producto ------------------- */
  function initVariantes() {
    var datos = document.querySelector('[data-al-variantes]');
    var contenedor = document.querySelector('[data-al-selectores]');
    if (!datos || !contenedor) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var formulario = document.getElementById('al-form-producto');
    if (!formulario) return;

    var campoId = formulario.querySelector('input[name="id"]');
    var boton = formulario.querySelector('[name="add"]');
    var precio = document.querySelector('[data-al-precio]');
    var selects = contenedor.querySelectorAll('select');
    if (!campoId || !selects.length) return;

    function actualizar() {
      var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });

      var encontrada = null;
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < elegidas.length; j++) {
          if (v.options[j] !== elegidas[j]) { coincide = false; break; }
        }
        if (coincide) { encontrada = v; break; }
      }

      if (!encontrada) {
        if (boton) { boton.disabled = true; boton.classList.add('al-pp-agotado'); }
        return;
      }

      campoId.value = encontrada.id;

      if (precio && typeof encontrada.price === 'number') {
        var simbolo = (precio.textContent.match(/^[^\d]*/) || [''])[0];
        var valor = (encontrada.price / 100).toLocaleString('es-CO', {
          minimumFractionDigits: 0, maximumFractionDigits: 2
        });
        precio.textContent = simbolo + valor;
      }

      if (boton) {
        boton.disabled = !encontrada.available;
        boton.classList.toggle('al-pp-agotado', !encontrada.available);
      }
    }

    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', actualizar);
    });
  }

  /* --- Formulario de pago contraentrega (Releasit) ---------------------- *
   * Cuando la app de contraentrega está activa, MANDA ELLA: su botón es el
   * único que abre el formulario en TODOS los dispositivos. Aquí solo
   * apartamos los nuestros para que no haya dos botones ni confusión.
   *
   * Aprendido a base de romperlo — no lo cambies sin volver a probar en móvil:
   *  · En escritorio Releasit intercepta además el botón del tema; disparar
   *    su botón con .click() desde el nuestro abría el formulario dos veces
   *    (salía con 2 unidades).
   *  · En MÓVIL no intercepta nada: usa su botón flotante de abajo. Si lo
   *    ocultas, el cliente acaba en la pantalla de pago de Shopify (PayPal)
   *    en lugar de en el formulario contraentrega. Es decir: no vendes.      */
  /* Textos de la app de contraentrega que vienen en inglés. Los traducimos
     en la propia web para no depender del panel de la app. Solo se tocan
     nodos de texto, nunca la estructura ni los eventos de sus botones. */
  var TRADUCCIONES_COD = {
    'Buy with Cash on Delivery': 'Pedir con pago contraentrega',
    'PAGO CONTRA REEMBOLSO': 'PAGO CONTRAENTREGA',
    'Shipping': 'Envío',
    'Shipping method': 'Forma de envío',
    'Free': 'Gratis',
    'Enter your shipping address': '¿A dónde se lo enviamos?',
    'Ingrese su dirección de envío': '¿A dónde se lo enviamos?',
    'Nombre de pila': 'Nombre',
    'Número cívico / Dirección 2': 'Barrio y punto de referencia',
    'Add to my order': 'Añadir a mi pedido',
    'No thank you, complete my order': 'No, gracias, completar mi pedido',
    'This field is required.': 'Este campo es obligatorio.',
    'Enter a valid value.': 'Escriba un valor válido.',
    'Enter a valid phone number.': 'Escriba un número de teléfono válido.',
    'Enter a valid email address.': 'Escriba un correo electrónico válido.',
    'Order summary': 'Resumen del pedido',

    // Combos de la app: las cifras no cuadraban con el descuento real
    // (29.900 y 69.800) y el "ahorra 0" del pack de 1 restaba en vez de sumar.
    'Ahorra $0 COP': 'Precio normal',
    'AHORRAS $30.000 COP': 'AHORRAS $29.900',
    'MÁXIMO AHORRO ($70.000 OFF)': 'MÁXIMO AHORRO: $69.800',
    '1 Unidad (Individual)': '1 Unidad',
    '2 Unidades — Pack Dúo (Para ti y una amiga/hermana)': '2 Unidades · una para ti y otra de regalo',
    '3 Unidades — Pack Familiar': '3 Unidades · el más pedido',
    'Pagar pedido': 'Pagar con tarjeta, PSE o Nequi',
    'Check out': 'Pagar con tarjeta, PSE o Nequi',
    'Apply': 'Aplicar',
    'Discount code': 'Código de descuento',

    // Verificación por SMS (OTP). La app los trae en inglés; si se activa sin
    // esto, el cliente ve una pantalla en inglés justo al confirmar el pedido.
    'Verify your phone number to complete your order': 'Verifique su número para completar el pedido',
    'Verify': 'Verificar',
    'Resend code': 'Reenviar código',
    'Change phone number': 'Cambiar número de teléfono',
    "Didn't receive your code?": '¿No le llegó el código?',
    'Your code': 'Su código',
    'The code you entered is not valid, please try again.': 'El código no es válido. Inténtelo de nuevo.',
    'You have reached the limit of resends, please try again with a different phone number.': 'Alcanzó el límite de reenvíos. Intente con otro número de teléfono.'
  };

  function traducirTextosCod(raiz) {
    var zona = raiz || document.body;
    if (!zona) return;

    var personalizado = window.AL_COD && window.AL_COD.boton;
    var recorrido = document.createTreeWalker(zona, NodeFilter.SHOW_TEXT, null);
    var nodo;
    var pendientes = [];

    while ((nodo = recorrido.nextNode())) {
      var original = nodo.nodeValue;
      var limpio = original.trim();
      if (!limpio) continue;

      var nuevo = null;
      if (limpio === 'Buy with Cash on Delivery' && personalizado) {
        nuevo = personalizado;
      } else if (Object.prototype.hasOwnProperty.call(TRADUCCIONES_COD, limpio)) {
        nuevo = TRADUCCIONES_COD[limpio];
      }

      if (nuevo && nuevo !== limpio) pendientes.push([nodo, original.replace(limpio, nuevo)]);
    }

    for (var i = 0; i < pendientes.length; i++) {
      pendientes[i][0].nodeValue = pendientes[i][1];
    }

    // Los nombres de los campos viven en atributos (placeholder / aria-label),
    // no en nodos de texto: hay que traducirlos aparte.
    var campos = zona.querySelectorAll ? zona.querySelectorAll('input, textarea, select') : [];
    for (var j = 0; j < campos.length; j++) {
      var campo = campos[j];
      var ph = campo.getAttribute('placeholder');
      if (ph && Object.prototype.hasOwnProperty.call(TRADUCCIONES_COD, ph.trim())) {
        campo.setAttribute('placeholder', TRADUCCIONES_COD[ph.trim()]);
      }
      var al = campo.getAttribute('aria-label');
      if (al && Object.prototype.hasOwnProperty.call(TRADUCCIONES_COD, al.trim())) {
        campo.setAttribute('aria-label', TRADUCCIONES_COD[al.trim()]);
      }
    }
  }

  function initTraduccionCod() {
    traducirTextosCod();

    // La app repinta su botón y su formulario: retraducimos cuando cambie.
    var observador = new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var c = cambios[i];
        if (c.addedNodes && c.addedNodes.length) {
          traducirTextosCod();
          return;
        }
      }
    });
    observador.observe(document.body, { childList: true, subtree: true });
  }

  function initReleasit() {
    var columna = document.querySelector('.al-pp-form');
    if (!columna) return;

    function suBoton() {
      var candidatos = columna.querySelectorAll('button:not(.al-btn), a[role="button"]:not(.al-btn)');
      for (var i = 0; i < candidatos.length; i++) {
        var c = candidatos[i];
        if (c.closest('.al-pp-miniaturas')) continue;
        if (c.type === 'submit' && c.name === 'add') continue;
        return c;
      }
      return null;
    }

    function cederElPaso() {
      var destino = suBoton();
      if (!destino) return false;
      destino.classList.add('al-cod-boton');
      document.body.classList.add('al-con-cod');
      return true;
    }

    if (cederElPaso()) return;

    // La app carga en diferido: esperamos a que aparezca su botón.
    var observador = new MutationObserver(function () {
      if (cederElPaso()) observador.disconnect();
    });
    observador.observe(columna, { childList: true, subtree: true });

    // Si en 12 s no aparece, la app no está: se queda nuestro botón normal.
    window.setTimeout(function () { observador.disconnect(); }, 12000);
  }


  /* --- Packs: contraentrega y pago anticipado (Bold) -------------------- *
   * Contraentrega: pone la cantidad del pack y abre el formulario de la app.
   * Pago anticipado: arma el carrito y manda al checkout de Shopify, donde
   * vive Bold (tarjeta, PSE, Nequi). Si el pack lleva descuento, se aplica
   * por /discount/CODIGO antes de entrar al checkout: sin eso el cliente
   * pagaria el precio sin combo.                                           */

  /* Lee cuantas unidades tiene marcado el selector de packs de la app.
     Los packs se titulan "1 Unidad", "2 Unidades"... asi que sacamos el
     primer numero del texto del que este seleccionado. Si no hay selector
     (o no se puede leer), devuelve 1. */
  function cantidadElegidaEnLaApp() {
    var marcados = document.querySelectorAll("input[type=radio]:checked");
    for (var i = 0; i < marcados.length; i++) {
      var fila = marcados[i].closest("label, li, div");
      var vuelta = 0;
      while (fila && vuelta < 4) {
        var texto = (fila.textContent || "").trim();
        var m = texto.match(/(d+)s*Unidad/i);
        if (m) return parseInt(m[1], 10);
        fila = fila.parentElement;
        vuelta++;
      }
    }
    return 1;
  }

  function initCombos() {
    var packsCod = document.querySelectorAll("[data-al-combo-cod]");
    var packsPago = document.querySelectorAll("[data-al-pago-anticipado]");
    if (!packsCod.length && !packsPago.length) return;

    packsCod.forEach(function (boton) {
      boton.addEventListener("click", function () {
        var cantidad = boton.getAttribute("data-cantidad") || "1";
        var campo = document.querySelector("#al-form-producto input[name=quantity]");
        if (campo) campo.value = cantidad;

        var abridor = document.querySelector(".al-cod-boton") ||
                      document.getElementById("al-boton-comprar");
        if (abridor) { abridor.click(); return; }

        var destino = document.querySelector("[data-al-barra-referencia]") ||
                      document.querySelector(".al-pp-form");
        if (destino) destino.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });

    packsPago.forEach(function (boton) {
      boton.addEventListener("click", function () {
        var variante = boton.getAttribute("data-variante");
        var cantidad = parseInt(boton.getAttribute("data-cantidad") || "1", 10);
        var descuento = (boton.getAttribute("data-descuento") || "").trim();

        // Boton de la pagina de producto: la cantidad manda el selector de la app
        if (boton.hasAttribute("data-cod2") || boton.hasAttribute("data-cod3")) {
          cantidad = cantidadElegidaEnLaApp();
          if (cantidad === 2) descuento = (boton.getAttribute("data-cod2") || "").trim();
          else if (cantidad === 3) descuento = (boton.getAttribute("data-cod3") || "").trim();
          else descuento = "";
        }
        if (!variante) return;

        var textoOriginal = boton.textContent;
        boton.textContent = "Un momento...";
        boton.disabled = true;

        fetch("/cart/clear.js", { method: "POST" })
          .then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: parseInt(variante, 10), quantity: cantidad })
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error("no se pudo agregar");
            window.location.href = descuento
              ? "/discount/" + encodeURIComponent(descuento) + "?redirect=/checkout"
              : "/checkout";
          })
          .catch(function () {
            boton.textContent = textoOriginal;
            boton.disabled = false;
            window.location.href = "/cart";
          });
      });
    });
  }

  /* --- Barra fija de compra en móvil ------------------------------------ */
  function initBarraCompra() {
    var barra = document.querySelector('[data-al-barra-compra]');
    var referencia = document.querySelector('[data-al-barra-referencia]');
    if (!barra) return;

    // Respaldo para navegadores sin :has() — que la barra no tape el pie.
    try {
      if (!CSS.supports('selector(body:has(div))')) {
        document.body.style.paddingBottom = '92px';
      }
    } catch (e) {
      document.body.style.paddingBottom = '92px';
    }

    if (!referencia || !('IntersectionObserver' in window)) return;

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        barra.classList.toggle('al-visible', !entrada.isIntersecting);
      });
    }, { threshold: 0 });

    observador.observe(referencia);
  }

  /* --- Acordeón de preguntas: solo una abierta a la vez ----------------- */
  function initFaq() {
    var items = document.querySelectorAll('[data-al-faq] details');
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otro) {
          if (otro !== item) otro.open = false;
        });
      });
    });
  }

  function init() {
    initReveals();
    initContadores();
    initGaleria();
    initVariantes();
    initReleasit();
    initCombos();
    initTraduccionCod();
    initBarraCompra();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializar.
  document.addEventListener('shopify:section:load', init);
})();
